import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { TLanguageIDs } from 'types';
import {
	ICustomerFullInfoContext,
	CustomerFullInfoContext,
} from '../../../../../../../../../../../customerFullInfoState/customerFullInfoContext';
import { ImgUploaderForStyleSettings } from 'components/ImgUploader/ImgUploaderForStyleSettings';
import style from './GroupImage.module.scss';

interface IGroupImage {
	filePath: Nullable<string>;
	translationId: string;
	isNeedImgHeading: boolean;
	itemKey: Nullable<string>;
	languageId: TLanguageIDs;
}

const GroupImage: React.FC<IGroupImage> = ({ filePath, translationId, isNeedImgHeading, itemKey, languageId }) => {
	const { selectedStyleLanguage } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	return (
		<div className={style.container}>
			{isNeedImgHeading && <Text translationNameSpace="mediaSettings" translationKey={itemKey} weight="bold" />}
			<div className={style.imgWrapper}>
				<ImgUploaderForStyleSettings
					translationID={filePath ? translationId : ''}
					photoSize="Medium"
					isMakeImageRequest={selectedStyleLanguage === languageId}
					loaderSize="big"
					noImageIdIcon="twoHills"
					filePath={filePath}
				/>
			</div>
		</div>
	);
};

export default GroupImage;
